<template>
  <div class="check-clock-date">
    <van-nav-bar title="编辑闹钟" :fixed="true" style="margin-bottom:15px;" left-text="返回" :border="false" left-arrow @click-left="backPage" />
    <div class="more-box">
      <van-datetime-picker
        confirm-button-text=" "
        cancel-button-text=" "
        type="time"
        visible-item-count="5"
        v-model="currentDate"
        @change="changeDatetime"
      />
      <!-- <div class="more-flex" @click="openPicker(true)">
        <span class="more-span">开始时间</span>
        <picker class="more-surplus" mode="time" @change="onInput($event,true)" :value="data.startTime">
          <p id="btn">{{data.startTime?data.startTime:'请设置'}}</p>
        </picker>
        <div class="arrows"></div>
      </div>
      <div class="more-flex" @click="openPicker(false)">
        <span class="more-span">结束时间</span>
        <picker class="more-surplus" mode="time" @change="onInput($event,false)" :value="data.endTime">
          <p>{{data.endTime?data.endTime:'请设置'}}</p>
        </picker>
        <div class="arrows"></div>
      </div> -->
    </div>
    <div class="more-box">
      <div class="more-flex" @click="toDateOption()">
        <span class="more-span">重复</span>
        <p class="more-surplus">{{clockData.days?clockData.days:'请设置'}}</p>
        <div class="arrows"></div>
      </div>
      <div class="more-flex" @click="showPicker=true">
        <span class="more-span">闹钟名称</span>
        <p class="more-surplus">{{clockData.title?clockData.title:'请设置'}}</p>
        <div class="arrows"></div>
      </div>
      <div class="more-flex">
        <span class="more-span">响铃方式</span>
        <p class="more-surplus more-surplus-type">{{ringMode}}</p>
      </div>
    </div>
    <div class="btn-box">
      <van-button round type="info" @click="save" :class="[!true?'save-opcity':'']">保存</van-button>
      <p v-if="isUpdate" class="delete-time" @click="deleteTime">删除此闹钟</p>
    </div>
    <van-popup v-model="showPicker" round @close="onClose">
      <div class="fill-number">
        <van-field
          v-model="value"
          placeholder="请输入闹钟名称"
          type="text"
          :maxlength='5'
          :border="true"
        />
        <div class="fill-btn">
          <van-button @click="onClose" class="fill-cancel" type="primary">取消</van-button>
          <van-button class="fill-confirm" type="primary" @click="ensure">确定</van-button>
        </div>
      </div>
    </van-popup>
    <van-dialog id="van-dialog" />
  </div>
</template>
<script>
export default {
  data () {
    return {
      imei:'',//设备imei
      checked:false,//开关状态
      value:'',//闹钟名称
      showPicker:false,//闹钟弹框
      isUpdate:false,//是不是修改
      currentDate: '12:00',
      clockData:{
        days:null,
        title:null
      },
      startOrEnd:false,
      updateStatus:1,
      ringMode:'',//闹钟模式
    }
  },
  created(){
    if(this.$route.query.data){
      let data = JSON.parse(this.$route.query.data)
      if(data.bool){
        this.clockData = data
        let arr = data.times.split(':')
        this.currentDate = parseInt(arr[0])+':'+parseInt(arr[1])
        this.$store.commit('set_currentDate', this.currentDate);
        this.isUpdate = true
        this.updateStatus = data.status
        this.ringMode = data.ringMode
      }else{
        this.currentDate = new Date().getHours()+':'+new Date().getMinutes()
        this.clockData = data
        this.isUpdate = false
        this.ringMode = data.ringMode
      }
    }
    if(this.$store.state.clockOption && this.$store.state.clockOption!=''){
      let res = JSON.parse(this.$store.state.clockOption);
      let arr = []
      res.forEach((item,index) => {
        if(item.isCheck){
          arr.push(item.text)
        }
      });
      let arr1 = ["周一","周二","周三","周四","周五"]
      let arr2 = ["周一","周二","周三","周四","周五","周六"]
      let arr3 = ["周一","周二","周三","周四","周五","周六","周日"]
      let flag1 = arr1.filter(val=>{
        return arr.indexOf(val)>-1
      })
      let flag2 = arr2.filter(val=>{
        return arr.indexOf(val)>-1
      })
      let flag3 = arr3.filter(val=>{
        return arr.indexOf(val)>-1
      })
      if(flag3.length===arr3.length){
        // this.$set(this.clockData, 'days', '周一至周日');
        this.clockData['days'] = '周一至周日'
      }else if(flag2.length===arr2.length){
        this.clockData['days'] = '周一至周六'
      }else if(flag1.length===arr1.length){
        this.clockData['days'] = '周一至周五'
      }else{
        this.clockData['days'] = arr.join(',')
      }
      this.$store.commit('set_clockOption', JSON.stringify(''));
    }
    if(this.$store.state.currentDate && this.$store.state.currentDate!=''){
      this.currentDate = this.$store.state.currentDate
    }
  },
  watch: {
    },
  mounted (){
  },
  methods: {
    /**
      * 返回上一级
      */
      backPage() {
          this.$router.back(-1);
      },
    /**
     * 确认输入名称
     */
    ensure(){
      this.clockData.title = this.value
      this.value = ""
      this.$forceUpdate();
      this.onClose()
    },
    //取消弹框
    onClose(){
      this.showPicker = false
    },
    toDateOption(){
      this.$router.push({ name: 'alarmDateOption' , query: { 'data': this.clockData.days } });
    },
    openPicker(bool){
      this.startOrEnd = bool;
      this.showPicker = true
    },
    //选择时间
    changeDatetime(picker){
      let arr = picker.getValues() //vant的用法
      this.currentDate = arr[0]+':'+arr[1]
      this.$store.commit('set_currentDate', this.currentDate);
    },
    //保存
    save(){
      if(!this.clockData.title || this.clockData.title==''){
        this.$toast({
          message: "请填写闹钟名称",
          icon: "none"
        });
        return
      }
      if(!this.clockData.days || this.clockData.days==''){
        this.$toast({
          message: "请选择重复时段",
          icon: "none"
        });
        return
      }
      let arr = {
        title:this.clockData.title,
        times:this.currentDate,
        days:this.clockData.days,
        // status:this.updateStatus?this.updateStatus:1
        status:1
      };
      let data = {
        ver:1,
        method:'sendAlarmClock',
        type:this.isUpdate?'update':'add',
        instructionId:this.$intfilter.instructFilter('闹钟设置'),
        index:this.isUpdate?this.clockData.index:'-1',
        paramArr:JSON.stringify(arr)
      }
      this.$http.get(this.$api.userInfo.POST_APPLET,data).then(res => {
          if (res.code === 0) {
            this.$toast({
              message: "保存成功",
              icon: "success"
            });
            this.$router.back(-1);
          } else {
            this.$toast({
                message: res.msg,
                duration: 2000,
                icon: require('@/assets/images/safety-fence/wrong.png'),
            });
          }
      })
    },
    //删除此时段
    deleteTime(){
      this.$dialog.confirm({
        title: '提示',
        message: '是否删除此闹钟？',
      })
        .then(() => {
          let arr = {
            title:this.clockData.title,
            times:this.currentDate,
            days:this.clockData.days,
            status:this.updateStatus?this.updateStatus:1
          };
          let data = {
            ver:1,
            method:'sendAlarmClock',
            type:'delete',
            index:this.clockData.index,
            instructionId:this.$intfilter.instructFilter('闹钟设置'),
            paramArr:JSON.stringify(arr)
          }
          this.$http.get(this.$api.userInfo.POST_APPLET,data).then(res => {
              if (res.code === 0) {
                this.$toast({
                  message: "已删除",
                  icon: "success"
                });
                this.$router.back(-1);
              } else {
                this.$toast({
                  message: res.msg,
                  duration: 2000,
                  icon: require('@/assets/images/safety-fence/wrong.png'),
                });
              }
          })
        })
        .catch(() => {
          // on cancel
        });
    }
  },

  beforeDestroy() {
    this.showPicker = false
  },
}
</script>

<style scoped>
.check-clock-date{
  background: #f8f8f8;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  padding: 100px 40px 0;
}
.check-clock-date .title{
  font-size: 30px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #666666;
  margin: 35px 0 35px 32px;
}
.more-box{
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fff;
  border-radius: 20px;
  margin-top: 25px;
}
.more-flex{
  display: flex;
  align-items: center;
  width: 670px;
  height: 101px;
}
.more-span{
  font-size: 30px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: #111111;
  margin-left: 32px;
}
.more-surplus{
  text-align: right;
  flex: 1;
  font-size: 30px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
}
.more-surplus-type{
  margin-right: 36px;
}
.arrows{
  width: 15px;
  height: 15px;
  transform:rotate(45deg);
  border-top: 3px solid #999;
  border-right: 3px solid #999;
  margin: 0 36px 0 20px;
}
.btn-box{
  z-index: 1;
  position: fixed;
  width: 100%;
  padding-bottom: 70px;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #f8f8f8;
}
.btn-box .delete-time{
  margin-top: 48px;
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #FC4D56;
}
.fill-number{
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 42px 32px 32px;
}
.fill-number .fill-btn{
  display: flex;
  justify-content: space-between;
  margin-top: 50px;
}
</style>
<style>
.check-clock-date .btn-box .van-button{
  margin: 0 auto;
  border: none;
  width: 586px;
  height: 98px;
  background: #01ADA9;
  color: #fff;
  border: 2px solid #01ADA9; 
}
.save-opcity .van-button{
  opacity: 0.3;
}
.check-clock-date .more-box .van-picker__toolbar{
  width: 500px;
}
.check-clock-date .more-box .van-picker__toolbar{
  height: 0px;
}
.check-clock-date .fill-number .van-button{
  width: 200px;
  height: 68px;
  line-height: 68px;
}
.check-clock-date .van-popup--round{
  top: 400px;
}
.check-clock-date .fill-number .fill-cancel{
  margin-right: 36px;
  background: #FFFFFF;
  border-radius: 34px;
  color: #01ADA9;
  border: 2px solid #01ADA9;  
}
.check-clock-date .fill-number .fill-confirm{
  background: #01ADA9;
  border-radius: 34px;
  border: 2px solid #01ADA9;
  color: #fff;
}
.check-clock-date .fill-number .van-field__control{
  text-align: center;
}
</style>
